import React from 'react';

export default function Badge({ label, color = '#fbbf24', icon = null, className = '' }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold shadow-sm border border-white/20 ${className}`}
      style={{ background: color, color: '#fff', marginLeft: 4 }}
    >
      {icon && <span className="mr-1">{icon}</span>}
      {label}
    </span>
  );
}
